import React, { FC } from "react";
import {
  Button as ChakraButton,
  ButtonProps,
  useStyleConfig,
} from "@chakra-ui/react";

const Button: FC<ButtonProps> = (props) => {
  const { variant, size, ...rest } = props;
  const styles = useStyleConfig("Button", { variant, size });
  return (
    <ChakraButton
      as="button"
      textStyle="button"
      colorScheme="pulpoGreen"
      sx={styles}
      {...rest}
    />
  );
};

export { Button };
